<template>
  <div class="detailPage">
    <div class="titleBox">
      <p class="title">基础信息</p>
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">交货单号：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpVbeln ? detailData.likpVbeln : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">客户名称：</div>
        <div class="right">
          <span class="value">
            {{ detailData.adrcName1 ? detailData.adrcName1 : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">销售组织：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpVkorg ? detailData.likpVkorg : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">销售工厂：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpVkorgTxt ? detailData.likpVkorgTxt : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">计划交货日期：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpWadat ? detailData.likpWadat : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">送达方：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpKunnr ? detailData.likpKunnr : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">售达方：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpKunag ? detailData.likpKunag : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">装运点：</div>
        <div class="right">
          <span class="value">
            {{ detailData.likpVstel ? detailData.likpVstel : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">最后同步时间：</div>
        <div class="right">
          <span class="value">
            {{ detailData.lastUpdateDateTime ? detailData.lastUpdateDateTime : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">修改次数：</div>
        <div class="right">
          <span class="value">
            {{ detailData.ver }}
          </span>
        </div>
      </li>
    </ul>
    <el-divider></el-divider>
    <div class="titleBox">
      <el-tabs  v-model="tabRecordPaneValue" @tab-click="tabRecordPaneClick">
      <el-tab-pane label="商品列表" name="first">
      </el-tab-pane>
      <el-tab-pane v-for="(item, index) in tabRecordPaneList" :key="item.id" :label="item.lipsVgbel" :name="item.id">
        <span slot="label">
          {{ item.lipsVgbel +"-" + item.lipsVgpos }}
          <i class="el-icon-circle-close" @click.stop="closeRecordTabPane(index)"></i>
        </span>
      </el-tab-pane>
      </el-tabs>
      <div class="btnBox">
            <div class="searchBtnBox">
              <el-button v-if="cutRecordView=='record'" type="primary" size="small" @click="onSearch">查询</el-button>
              <el-button v-if="cutRecordView=='record'" type="primary" size="small" @click="batchBack">退货</el-button>
            </div>
          </div>     
      
    </div>
    <!-- 查询条件 -->
    <el-form
        :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox" v-if="cutRecordView=='record'">
          <el-form-item label="交货单号" size="small" v-if="tabRecordPaneValue == 'first' ">
            <el-input v-model="searchConditionForm.orderId" placeholder="交货单号" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="SN" size="small">
            <el-input v-model="searchConditionForm.sn" placeholder="SN" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
        </div>
      </el-form>
    <el-table v-if="tabRecordPaneValue == 'first' " stripe border style="width: 100%" size="mini"
      :data="detailData.items">
      <el-table-column min-width="50px"
        label="项目号" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsPosnr ? scope.row.lipsPosnr : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="100px"
        label="销售单号" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.lipsVgpos" :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsVgbel ? scope.row.lipsVgbel +"-" + scope.row.lipsVgpos : '-' }}</span>
          <span v-else :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsVgbel ? scope.row.lipsVgbel : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="PO/PI" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.vbakBstnk ? scope.row.vbakBstnk : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="120px"
        label="存货编码" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.maktMaktx" :content="scope.row.maktMaktx" class="item" effect="dark" placement="top" :open-delay="300">
            <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsMatnr ? scope.row.lipsMatnr : '-' }}</span>
          </el-tooltip>
          <span v-else :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsMatnr ? scope.row.lipsMatnr : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="产品型号" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.zc0011 ? scope.row.zc0011 : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="业务员" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.p0001Ename">{{ scope.row.vbapPerveAna ? scope.row.vbapPerveAna+"("+scope.row.p0001Ename+")" : '-' }}</span>
          <span v-else>{{ scope.row.vbapPerveAna ? scope.row.vbapPerveAna : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="客户型号" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.zc0018 ? scope.row.zc0018 : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="客户物料号" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.lipsKdmat ? scope.row.lipsKdmat : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="100px"
        label="交货数量" align="center" prop="allowSkip" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.status && scope.row.status.code=='EX_WAREHOUSE'" class="allowSkip" @click="clickRecorkSkip(scope.row)">
            <span v-if="scope.row.lipsMeins" :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsLfimg ? scope.row.lipsLfimg+scope.row.lipsMeins : '-' }}</span>
            <span v-else :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsLfimg ? scope.row.lipsLfimg : '-' }}</span>
          </div>          
          <div v-else>
            <span v-if="scope.row.lipsMeins" :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsLfimg ? scope.row.lipsLfimg+scope.row.lipsMeins : '-' }}</span>
            <span v-else :class="{disabled_user: !scope.row.enable}">{{ scope.row.lipsLfimg ? scope.row.lipsLfimg : '-' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="workStation" width="95px" label="状态" align="center">
        <template slot-scope="scope">
            <span :class="{disabled_user: !scope.row.enable}">{{ scope.row.status ? scope.row.status.title : "-" }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="width: 100%; min-height: 350px; height: calc(100vh - 500px);" v-if="cutRecordView=='record' && tabRecordPaneValue!='first'">
        <shipmentOrderItemRecordPage
              ref="shipmentOrderItemRecordPage"
              :tabPaneValue="tabRecordPaneValue" :cutView="cutRecordView" :pagination="pagination" :searchConditionForm="searchConditionForm"
              ></shipmentOrderItemRecordPage>

        <pagination
        :pagination="pagination"
        @currentChange="currentRecordChange"
        @sizeChange="sizeRecordChange"
        @refreshBtn="getSapOrderSearch"
      ></pagination>
    </div>
  </div>
</template>
<script>
import pagination from "@/components/pagination.vue";
import shipmentOrderItemRecordPage from "./shipmentOrderItemRecordPage.vue";
import {
  apiSapShipmentDetail, 
} from "@/api/SapOrder.js";
export default {
  components: {
    pagination,
    shipmentOrderItemRecordPage
  },
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
  },
  data() {
    return {
      cutRecordView: "first",
      detailData: {},
      tabRecordPaneValue: "first",
      tabRecordPaneData: {},
      tabRecordPaneList: [],
      searchConditionForm: {},
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
    };
  },
  watch:{
    tabRecordPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.$nextTick(() => {
          this.detail();
        });
      } else {
        this.$nextTick(() => {
          this.tabRecordPaneData=null;
          this.tabRecordPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabRecordPaneData = item;
              if(this.cutRecordView=='record') {
                this.searchConditionForm.orderId = item.id;
                this.$refs.shipmentOrderItemRecordPage.onSearch(this.searchConditionForm);
              }
            }
          });
          
        });
      }
    }
  },
  methods: {
    // 切换记录页一级面板
    tabRecordPaneClick(tab) {
      this.tabRecordPaneValue = tab.name;
    },
    // 关闭一级面板
    closeRecordTabPane(index) {
      if (this.tabRecordPaneList[index].id == this.tabRecordPaneValue) {
        if (index > 0) {
          this.tabRecordPaneValue = this.tabRecordPaneList[index - 1].id;
        } else {
          this.tabRecordPaneValue = "first";
        }
      }
      this.tabRecordPaneList.splice(index, 1);
    },
    // 详情
    async detail() {
      const res = await apiSapShipmentDetail({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.detailData = res.data;
      }
    },
    // 表格数据
    async getSapOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      if(this.cutRecordView=='record') {
        this.$refs.shipmentOrderItemRecordPage.onSearch();
      }
      if (callback) callback();
    },
    onSearch(){
      this.$refs.shipmentOrderItemRecordPage.onSearch();
    },
    // 点击表格编号
    clickRecorkSkip(row) {
      this.cutRecordView="record";
      this.tabRecordPaneValue = row.id;
      this.searchConditionForm.orderId = this.tabRecordPaneValue;
      let tabPaneIds = this.tabRecordPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabRecordPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabRecordPaneList.push(row);
      }
    },
    // 页码改变
    currentRecordChange(val) {
    this.pagination.currentPage = val;
    this.getSapOrderSearch();
    },
    // 页容量改变
    sizeRecordChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getSapOrderSearch();
    },  
    batchBack() {
      this.$refs.shipmentOrderItemRecordPage.batchBack();
    },  
    },

};
</script>

<style lang="less" scoped>
  .reCheck {
    color: #f56c6c; font-weight: bold; font-size: 16px;
  }
  .btnBox{
    position: relative;
    top: 10px;
  }
  .disabled_user {
    text-decoration: line-through;
  }
</style>
